export const formRules = {
  "username-email": [
    {
      required: true,
      message: "Username or Email is required",
    },
    {
      pattern: /^(?:(?!.*\s).+|[^@\s]+@[^@\s]+\.[^@\s]+)$/,
      message:
        "Please enter a valid username (without spaces) or email address",
    },
  ],
  password: [
    {
      required: true,
      message: "Password is required",
    },
  ],
};